module.exports = __webpack_public_path__ + "static/media/error-ad.f125c85f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/partner-reports/error-ad.svg
// module id = 1122
// module chunks = 1